// src/api/admin.js
import client from "./client"; // axios client

function authHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Admin API helpers
 * NOTE: client.baseURL should be the server origin (e.g. http://localhost:3000)
 * These helpers call the canonical /api/admin/* endpoints.
 */

export async function fetchUsers({ token, page = 0, limit = 50, q, city, pincode, role, blocked }) {
  const params = { page, limit };
  if (q) params.q = q;
  if (city) params.city = city;
  if (pincode) params.pincode = pincode;
  if (role) params.role = role;
  if (typeof blocked !== "undefined") params.blocked = blocked ? "1" : "0";

  const res = await client.get("/api/admin/users", { params, headers: authHeaders(token) });
  return res.data;
}

export async function getUserDetails({ token, id }) {
  const res = await client.get(`/api/admin/users/${id}`, { headers: authHeaders(token) });
  return res.data;
}

export async function blockUser({ token, id, block = true }) {
  const res = await client.put(`/api/admin/users/${id}/block`, { block }, { headers: authHeaders(token) });
  return res.data;
}

export async function exportUsers({ token, format = "csv", q, city, pincode, role, blocked }) {
  const params = { format };
  if (q) params.q = q;
  if (city) params.city = city;
  if (pincode) params.pincode = pincode;
  if (role) params.role = role;
  if (typeof blocked !== "undefined") params.blocked = blocked ? "1" : "0";

  const res = await client.get("/api/admin/users/export", {
    params,
    headers: authHeaders(token),
    responseType: "blob",
  });
  return res;
}
